export default __webpack_public_path__ + "static/media/new-2.5bef75ed.png";